import React, { PureComponent } from 'react';
import styled from 'styled-components';

import WelcomeData from "../../../data/onboarding/welcome.json";

import WelcomeVideoRound1 from '../../../containers/assets/onboarding-welcome-round1.mp4';
import WelcomeVideoRound2 from '../../../containers/assets/onboarding-welcome-round2.mp4';
import WelcomeVideoRound3 from '../../../containers/assets/onboarding-welcome-round3.mp4';

const roundsVideos = [
  WelcomeVideoRound1,
  WelcomeVideoRound2,
  WelcomeVideoRound3
]

const level1Controls = [
  { time: 0, timeLabel: 0, label: "Overview" },
  { time: 32, timeLabel: 30, label: "Research" },
  { time: 48, timeLabel: 40, label: "The Decisions" },
  { time: 103, timeLabel: 100, label: "Sales Process" },
  { time: 147, timeLabel: 135, label: "Review" }
];

const level2Controls = [
  { time: 0, timeLabel: 0, label: "Overview" },
  { time: 18, timeLabel: 15, label: "Customer" },
  { time: 26, timeLabel: 25, label: "Product" },
  { time: 62, timeLabel: 62, label: "Operations" },
  { time: 87.5, timeLabel: 90, label: "Finance" }
];

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  background: #3A507B;

  &:before {
    display: block;
    content: '';
    align-items: center;
    background: #0006;
    display: flex;
    justify-content: center;
    opacity: 1;
    position: absolute;
    left: 15px;
    right: 15px;
    top: 15px;
    bottom: 15px;
    transition: opacity .3s ease;
    border-radius: 5px;
  }

  &.is-playing:before, &.is-playing button {
    opacity: 0;
  }
  &.is-playing:hover:before, &.is-playing:hover button {
    opacity: 1;
  }
  &:hover video {
    cursor: pointer;
  }
`;

const PlayPauseButton = styled.button`
  align-items: center;
  background: none;
  background: #2a4169;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #0000001a;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 2rem;
  height: 80px;
  justify-content: center;
  padding: 0;
  text-align: center;
  width: 80px;
  z-index: 2;
  position: absolute;
  transition: opacity .3s ease;
  opacity: 1;
`;

const ControlButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

const ControlButton = styled.button`
  border-radius: 4px;
  padding: 2px 15px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-family: Mukta Vaani;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
`;

const ControlButtonFirstLine = styled.span`
  color: #5C91F5;
`;

const ControlButtonSecondLine = styled.span`
  color: rgba(0, 27, 59, 0.94);
`;

class WelcomeStep1 extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
    };
    this.videoRef = null;
  }

  handlePlayPause = () => {
    if (this.videoRef) {
      if (this.state.isPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.setState({ isPlaying: !this.state.isPlaying });
    }
  };

  seekTo = (time) => {
    if (this.videoRef) {
      this.videoRef.currentTime = time;
      this.videoRef.play();
      this.setState({ isPlaying: true })
    }
  };

  render() {
    const { roundInUrl, currentRound } = this.props;
    const activeRound = roundInUrl || currentRound;

    const validVideoIndex = activeRound - 1 < roundsVideos.length ? activeRound - 1 : 0;
    const { isPlaying } = this.state;

    const controls = currentRound === 2 ? level2Controls : level1Controls;

    return (
      <Wrapper>
        <Container>
          <Text1>{WelcomeData.rounds[activeRound - 1].text1}</Text1>
          <Text2>{WelcomeData.rounds[activeRound - 1].text2}</Text2>
          <Text3 dangerouslySetInnerHTML={{ __html: WelcomeData.rounds[activeRound - 1].text3 }} />

          <VideoWrapper className={isPlaying ? 'is-playing' : ''}>
            <video
              ref={(ref) => { this.videoRef = ref; }}
              src={roundsVideos[validVideoIndex]}
              alt="Welcome Video"
              onClick={this.handlePlayPause}
              onEnded={() => this.setState({ isPlaying: false })}
              style={{ width: '100%', borderRadius: 5 }}
            />
            <PlayPauseButton onClick={this.handlePlayPause}>
              {isPlaying ? '❚❚' : '▶'}
            </PlayPauseButton>
          </VideoWrapper>

          {
            currentRound < 3 &&
            <ControlButtonsRow>
              {controls.map(({ time, timeLabel, label }, index) => (
                <ControlButton key={index} onClick={() => this.seekTo(time)}>
                  <ControlButtonFirstLine>From ({new Date(timeLabel * 1000).toISOString().substr(14, 5)})</ControlButtonFirstLine>
                  <ControlButtonSecondLine>{label}</ControlButtonSecondLine>
                </ControlButton>
              ))}
            </ControlButtonsRow>
          }
        </Container>
      </Wrapper>
    );
  }

}

export default WelcomeStep1;



// WEBPACK FOOTER //
// ./src/components/onboarding/welcome/Step1.js